'use strict';
angular
   .module('com.vmware.vsphere.client.vm')
   .constant('diskBackingInfoConstants', {
      FLATVER2:         'com.vmware.vim.binding.vim.vm.device.VirtualDisk$FlatVer2BackingInfo',
      RAWDISKMAPPING:  'com.vmware.vim.binding.vim.vm.device.VirtualDisk$RawDiskMappingVer1BackingInfo',
      SESPARSE: "com.vmware.vim.binding.vim.vm.device.VirtualDisk$SeSparseBackingInfo",
      LOCALPMEM: "com.vmware.vim.binding.vim.vm.device.VirtualDisk$LocalPMemBackingInfo"
   });
